<script setup lang="ts">
import { useAuth0 } from '@auth0/auth0-vue';
import { clearDatadogRumUser } from '@marketspark/ui/utils/datadog-rum';
import { onMounted } from 'vue';

const { logout } = useAuth0();

onMounted(() => {
  clearDatadogRumUser();
  logout({
    logoutParams: {
      returnTo: import.meta.env.VITE_EIKON_APP_URL,
    },
  });
});
</script>
<template>Logging out...</template>
